import React, { useState } from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Switch } from "../../../components/ui/switch";
import { API, fileUpload } from "../../../config";
import { UserCog2Icon } from "lucide-react";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import RolePermission from "./RolePermission";

const RoleActionButton = ({
  id,
  setEdit,
  setRoleId,
  toggleShowAddEditRole,
  toggleShowDelete,
  statusMode = false,
  status,
  setLoading,
  fetchRoleData,
  roleData,
}) => {
  const [showPermission, setShowPermission] = useState();

  const toggleShowPermission = () => {
    setShowPermission(!showPermission);
  };

  const handleSucess = () => {
    toggleShowPermission();
    fetchRoleData();
  };

  const handleRoleStatus = async (id, status) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("status", status ? 0 : 1);
      formData.append("id", id);

      const { data } = await fileUpload(
        `${API.ADMIN_ROLE_STATUS}`,
        formData,
        {}
      );
      setLoading(false);
      if (data) {
        fetchRoleData();
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      {statusMode ? (
        <>
          <div className="flex items-center space-x-2">
            <span className="text-sm font-medium">Active</span>
            <Switch
              checked={status ? true : false}
              onCheckedChange={(e) => handleRoleStatus(id, status)}
              className="data-[state=checked]:bg-webPrimary"
            />
          </div>
        </>
      ) : (
        <span className="flex items-center gap-2 justify-center">
          <CustomTooltip message={"Edit"}>
            <span>
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                onClick={() => {
                  setEdit(true);
                  toggleShowAddEditRole();
                  setRoleId(id);
                }}
              />
            </span>
          </CustomTooltip>
          <span>/</span>
          <CustomTooltip message={"Delete"}>
            <span>
              <FontAwesomeIcon
                icon={faTrash}
                size="1x"
                onClick={() => {
                  setRoleId(id);
                  toggleShowDelete();
                }}
              />
            </span>
          </CustomTooltip>
          <span>/</span>
          <CustomTooltip message={"Role Permission"}>
            <span>
              <UserCog2Icon
                size={16}
                onClick={() => {
                  setRoleId(id);
                  toggleShowPermission();
                }}
              />
            </span>
          </CustomTooltip>
        </span>
      )}

      <ResponsiveDrawerForm
        description={""}
        title={"Role Permission"}
        handleOpen={() => {}}
        handleClose={() => {}}
        buttonText={""}
        className={"sm:max-w-[90vw] overflow-hidden"}
        setOpen={setShowPermission}
        open={showPermission}
      >
        <RolePermission
          expandList={true}
          roleId={id}
          roleData={roleData}
          handleSucess={handleSucess}
        />
      </ResponsiveDrawerForm>
    </>
  );
};

export default RoleActionButton;
